import React from 'react';
import toast from 'react-hot-toast';

export const confirmAction = (message, onConfirm) => {
  toast((t) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '4px' }}>
      <p style={{ margin: 0, fontWeight: 500, color: '#333', fontSize: '15px' }}>{message}</p>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button 
          style={{ 
            padding: '6px 14px', 
            borderRadius: '6px', 
            border: '1px solid #d1d5db', 
            background: '#fff', 
            color: '#374151', 
            cursor: 'pointer', 
            fontWeight: 500,
            fontSize: '14px',
            transition: 'all 0.2s'
          }}
          onClick={() => toast.dismiss(t.id)}
          onMouseOver={(e) => e.target.style.background = '#f3f4f6'}
          onMouseOut={(e) => e.target.style.background = '#fff'}
        >
          Cancel
        </button>
        <button 
          style={{ 
            padding: '6px 14px', 
            borderRadius: '6px', 
            border: 'none', 
            background: '#ef4444', 
            color: 'white', 
            cursor: 'pointer', 
            fontWeight: 500,
            fontSize: '14px',
            transition: 'all 0.2s'
          }}
          onClick={() => {
            toast.dismiss(t.id);
            onConfirm();
          }}
          onMouseOver={(e) => e.target.style.background = '#dc2626'}
          onMouseOut={(e) => e.target.style.background = '#ef4444'}
        >
          Confirm
        </button>
      </div>
    </div>
  ), { 
    duration: Infinity, 
    position: 'top-center',
    style: {
      minWidth: '320px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      border: '1px solid #f3f4f6',
      background: '#fff',
      padding: '16px'
    }
  });
};
